/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingIdRemarkRuleStateResponse
 */
export interface BookingIdRemarkRuleStateResponse {
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleStateResponse
     */
    errorMessage?: string | null;
}

export function BookingIdRemarkRuleStateResponseFromJSON(json: any): BookingIdRemarkRuleStateResponse {
    return BookingIdRemarkRuleStateResponseFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function BookingIdRemarkRuleStateResponseToJSON(value?: BookingIdRemarkRuleStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


